import { Injector } from "@angular/core";
import LoggerService from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export const loggerBootstrap: (injector?: Injector) => Promise<Injector | void> = (injector) => {
  let xhr = new XMLHttpRequest();
  let resolve;
  const promise: Promise<Injector | void> = new Promise((res) => {
    resolve = res;
  });

  xhr.open("GET", "/assets/JSON/logger.json", true);
  xhr.onload = function (e) {
    let loggerConfig = {};
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        loggerConfig = JSON.parse(xhr.responseText);
      }
    }
    LoggerService.configure(loggerConfig);
    if (injector != null) {
      resolve(injector);
    } else {
      resolve();
    }
  };

  xhr.onerror = function (e) {
    xhr.onload.call({});
    logger.out.warn("main() no logger configuration %O", e);
    return;
  };
  xhr.send(null);

  return promise;
};
